import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { ConfirmationDialogComponent } from "./confirmation-dialog.component";
import { ConfirmationDialogService } from "./confirmation-dialog.service";


@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
    ],

    declarations: [ConfirmationDialogComponent],
    exports: [ConfirmationDialogComponent],
    providers: [ConfirmationDialogService],
})
export class ConfirmationDialogModule {}